import { RouteWrapper } from '../../component';
import Header from '../../component/header/index';
import NavigationHeader from '../../component/navigation_header';
import ScreenBackgroundWrapper from '../../component/screen_background_wrapper';
import SideBar from '../../component/sidebar';
import { isSmartPhone } from '../../utilities/helper';
import './index.css';
import { useLink } from 'react-router-stack';
import useWindowOrientation from '../../utilities/hooks/useWindowOrientation';
import LoginSignUpModal from '../../component/login_signup_modal';
import { useSelector } from 'react-redux';
const DefaultContainer = ({
  children,
  isWelcomeMessage = true,
  isNavigationHeader = false,
  navigationTitle = ''
}: any) => {
  const { isLoginModal = false } = useSelector((state: any) => state.user);

  const navigate = useLink();

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };
  const { isLandscape } = useWindowOrientation();
  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        {!isSmartPhone && (
          <div className="default_container_wrapper">
            <SideBar />
            <div className="default_container_primary_container">
              <Header isWelcomeMessage={isWelcomeMessage} />
              <div className="default_container_content_wrapper">{children}</div>
            </div>
          </div>
        )}
        {isSmartPhone && (
          <div className="default_container_wrapper_mWeb">
            <div className="default_container_primary_container_mWeb">
              {!isNavigationHeader ? (
                <Header isWelcomeMessage={isWelcomeMessage} />
              ) : (
                <NavigationHeader
                  onClickBack={onClickBack}
                  title={navigationTitle}
                  bgColor={true}
                />
              )}
              <div
                className={`default_container_content_wrapper_mWeb ${
                  isLandscape ? 'default_container_content_landscape_wrapper' : ''
                }`}>
                {children}
              </div>
            </div>
          </div>
        )}
        <LoginSignUpModal visible={isLoginModal} onPressClose={() => {}} />
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default DefaultContainer;
